import { Panel, PanelTheme, PanelBorderStyle, PanelBorderRadius, Button, ButtonTheme } from '@apply/components';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router';
import { useBorrowerEntityName } from '../../../queries/BorrowerFields/EntityFields';
import { useAddPropertyToCache } from '../../Property/queries/useAddPropertyToCache';

export interface AddAnotherPropertyPanelProps {
    entryGuid: string | undefined;
    printMode?: boolean;
}

export const AddAnotherPropertyPanel: React.FC<AddAnotherPropertyPanelProps> = ({ entryGuid, printMode = false }) => {
    const navigate = useNavigate();
    const [borrowerEntityName] = useBorrowerEntityName();
    const addPropertyToCache = useAddPropertyToCache();

    const addPropertyClick = () => {
        const propertyGuid = uuidv4();
        addPropertyToCache(propertyGuid);
        window.scrollTo(0, 0);
        navigate(`/property/${entryGuid}?pid=${propertyGuid}`);
    };

    return (
        <>
            {!printMode && (
                <Panel
                    theme={PanelTheme.Gray}
                    borderStyle={PanelBorderStyle.Solid}
                    borderRadius={PanelBorderRadius.Medium}
                >
                    <div className='addAnotherPropertyPanel'>
                        <div className='addAnotherPropertyPanel-text'>
                            You can Add Another Property to this application but it
                            <span style={{ fontWeight: 600 }}> must also be owned by {borrowerEntityName}</span> otherwise start a
                            new application.
                        </div>
                        <div className='addAnotherPropertyPanel-button'>
                            <Button
                                theme={ButtonTheme.Secondary}
                                id='addAnotherPropertyButton'
                                dataTestid='addAnotherPropertyButton'
                                type='button'
                                width='200px'
                                height='30px'
                                handleClick={addPropertyClick}
                            >
                                Add Another Property
                            </Button>
                        </div>
                    </div>
                </Panel>
            )}
        </>
    );
};
